import type { Settings } from "./settings";

/**
 * Where the media events of every publish attempt go, for both publishing paths of the
 * SDK (my own medias and the streams this page republishes). Reporting itself is not
 * configurable: both paths report whenever they publish. Undefined lets the SDK derive
 * the route from each publish URL's host, which is what every deployment but the local
 * dev stack wants.
 */
export const resolveMediaEventsEndpoint = (settings: Pick<Settings, "mediaEvents">): string | undefined =>
  settings.mediaEvents?.endpoint?.trim() || undefined;
